<template>
  <div class="transition-global">
    <div class="totemBG tw-bg-cover tw-w-full tw-h-full tw-absolute">
      <div class="scan-page-header tw-text-center">
        <vLogoDefault width="clamp(180px, 28.5vw, 310px)" />
      </div>
      <div class="scan-page-content tw-z-10 tw-w-full">
        <div class="scan-page-layout">
          <div class="tw-items-center tw-text-center tw-text-white">
            <h1 class="scan-page-title">Envio de Fotos</h1>
            <div class="scan-upload-card">
              <h2 class="scan-upload-instruction">
                USE A CÂMERA DO SEU CELULAR<br />PARA LER O QR CODE
              </h2>
              <div class="qrcodeBorder">
                <div
                  v-if="loadingQRCODE"
                  class="scan-qr-placeholder tw-flex tw-flex-col tw-items-center tw-justify-center"
                >
                  <svg
                    v-if="!erroQRCODE"
                    class="qr-loader"
                    viewBox="0 0 100 100"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <linearGradient
                        id="qrLoaderGrad"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop offset="0%" stop-color="#ffffff" />
                        <stop offset="100%" stop-color="#f0b6dc" />
                      </linearGradient>
                    </defs>
                    <circle
                      class="qr-loader-track"
                      cx="50"
                      cy="50"
                      r="42"
                    />
                    <circle
                      class="qr-loader-arc"
                      cx="50"
                      cy="50"
                      r="42"
                    />
                  </svg>
                  <span
                    v-if="!erroQRCODE"
                    class="tw-text-2xl tw-mt-5 tw-text-white tw-font-semibold"
                    >Gerando QR Code...</span
                  >
                  <template v-else>
                    <span
                      class="tw-text-2xl tw-mt-5 tw-text-white tw-font-semibold tw-text-center tw-px-4"
                      >Não foi possível gerar o QR Code.</span
                    >
                    <button
                      class="btn-tentar-novamente tw-mt-4 tw-px-6 tw-py-3 tw-rounded-xl tw-text-xl tw-font-semibold"
                      @click="carregarQRCODE()"
                    >
                      Tentar novamente
                    </button>
                  </template>
                </div>
                <img
                  v-else
                  draggable="false"
                  @contextmenu.prevent
                  @dragstart.prevent
                  :src="dataImagem"
                  class="scan-qr-code"
                />
              </div>
            </div>
            <CustomerWifiAccess />
            <p class="scan-page-attention">Atenção!</p>
            <p class="scan-page-notice">É necessário estar conectado à internet.</p>
          </div>
        </div>
      </div>
    </div>

    <vTimeout
      id="SCAN_QR_CODE"
      :timeEtapa="GET_COMPRA.etapa"
      :segundos="$root.getTimeoutName('SCAN_QR_CODE')"
    />

    <vFloatGuide :destinoBack="getRouterBack" :next="false" />
  </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";
import { createCode } from "@/service/firebase";
import { baseURL } from "@/constants/base_url";
import QRCode from "qrcode";
import CustomerWifiAccess from "@/components/assistance/CustomerWifiAccess.vue";
import vFloatGuide from "@/components/floatGuide";
import etapas from "@/constants/etapaCompra.js";
export default {
  components: {
    CustomerWifiAccess,
    vFloatGuide,
  },
  data() {
    return {
      dataImagem: "",
      loadingQRCODE: true,
      erroQRCODE: false,
      destruido: false,
    };
  },
  async beforeMount() {
    await this.carregarQRCODE();
  },
  mounted() {
    this.animaMounted();
  },
  beforeDestroy() {
    this.destruido = true;
  },
  computed: {
    getRouterBack() {
      return this.$store.getters["totem/getTotem"]?.config?.selfie
        ? etapas.MODO_CAPTURA : etapas.QTDE_FOTO;
    },
    getEtapas() {
      return etapas;
    },
    GET_COMPRA() {
      return this.$store.getters["compra/getCompra"];
    },
  },
  methods: {
    getURL() {
      let code = this.$store.getters["compra/getCode"];
      let transfer = `${baseURL}init/${code}`;
      return transfer;
    },
    async carregarQRCODE() {
      const maxTentativas = 3;
      const intervaloMs = 1000;
      this.loadingQRCODE = true;
      this.erroQRCODE = false;
      for (let tentativa = 1; tentativa <= maxTentativas; tentativa++) {
        // Se o componente foi destruído durante a espera, aborta.
        if (this.destruido) return;
        try {
          // Só cria um novo code se ainda não existir, para não gerar
          // códigos órfãos no servidor a cada tentativa.
          if (!this.$store.getters["compra/getCode"]) {
            const compraID = this.$store.getters["compra/getID"];
            await createCode(compraID);
          }
          await this.gerarQRCODE();
          if (this.destruido) return;
          this.loadingQRCODE = false;
          this.erroQRCODE = false;
          return;
        } catch (err) {
          console.error(
            `Falha ao gerar o QR Code (tentativa ${tentativa}/${maxTentativas})`,
            err
          );
          // Aguarda antes de tentar novamente, exceto após a última tentativa.
          if (tentativa < maxTentativas) {
            await new Promise((resolve) => setTimeout(resolve, intervaloMs));
          }
        }
      }
      // Após 3 tentativas sem sucesso, NÃO deixamos a tela em loading eterno:
      // isso era um congelamento permanente para o cliente (e o vTimeout não
      // socorre enquanto ele continua tocando a tela). Mostramos o erro com um
      // botão de "Tentar novamente", que só dispara sob ação do usuário — sem
      // marteladas automáticas no servidor.
      if (this.destruido) return;
      this.erroQRCODE = true;
      this.$root.sendOneError(
        "Não foi possível gerar o QR Code após 3 tentativas",
        "scanQrCode/carregarQRCODE"
      );
    },
    gerarQRCODE() {
      const transfer = this.getURL();
      return QRCode.toDataURL(transfer, { errorCorrectionLevel: "H" }).then(
        (url) => {
          if (this.destruido) return;
          this.dataImagem = url;
        }
      );
    },
    animaMounted() {
      anime({
        targets: ".transition-global",
        opacity: {
          value: 1,
          delay: 0,
          duration: 1000,
          easing: "easeInOutExpo",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.transition-global {
  --scan-qr-size: clamp(190px, 36.2vw, 392px);
  opacity: 0;
}

.scan-page-header {
  flex-shrink: 0;
  padding-top: clamp(4px, 0.5vh, 12px);
}
.scan-page-content {
  display: block;
  flex: 1;
  margin-top: clamp(12px, 1.5vh, 24px);
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 1rem;
}
.scan-page-layout {
  margin: 0 auto;
  max-width: 1200px;
  width: 90%;
}
.scan-page-title {
  font-size: clamp(28px, 4.4vw, 48px);
  font-weight: 400;
  line-height: 1.15;
  margin: 0 0 clamp(14px, 1.5vw, 18px);
}
.scan-upload-card {
  background: #8c2667;
  border-radius: clamp(18px, 3.3vw, 36px);
  box-sizing: border-box;
  margin: 0 auto;
  padding: clamp(24px, 4.4vw, 48px);
  width: 96.3%;
}
.scan-upload-instruction {
  font-size: clamp(24px, 4.6vw, 50px);
  font-weight: 700;
  line-height: 1.28;
  margin: 0 0 clamp(20px, 3.1vw, 34px);
}
.scan-qr-code {
  display: block;
  height: auto;
  width: 100%;
}
.scan-qr-placeholder {
  height: var(--scan-qr-size);
  width: var(--scan-qr-size);
}
.scan-page-attention,
.scan-page-notice {
  font-size: clamp(22px, 3.3vw, 36px);
  line-height: 1.35;
  margin: 0;
}
.scan-page-attention {
  font-weight: 700;
  margin-bottom: 10px;
}
.customBorder {
  border-color: #98a1bb;
  border-width: 1px;
  border-spacing: 30px;
  @apply tw-border-dashed
        tw-w-full
        tw-h-full
        tw-flex
        tw-flex-col
        tw-items-center
        tw-justify-center
        tw-rounded-full
        tw-border-gray-400;
}
.polaroidColorBG {
  background-color: rgba(72, 87, 236, 0.2);
}
.comumColorBG {
  background-color: rgba(255, 51, 68, 0.2);
}
.totemBG {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 13rem;
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../assets/fundo.png");
}
.qrcodeBorder {
  display: block;
  margin: 0 auto;
  width: var(--scan-qr-size);
}

@media (min-aspect-ratio: 1/1) {
  .transition-global {
    --scan-qr-size: clamp(160px, 22vh, 300px);
  }
  .scan-page-content {
    margin-top: 0;
  }
  .scan-page-title {
    font-size: clamp(26px, 3.5vh, 40px);
    margin-bottom: 12px;
  }
  .scan-upload-card {
    padding: clamp(16px, 2.5vh, 28px);
  }
  .scan-upload-instruction {
    font-size: clamp(24px, 3.5vh, 40px);
    line-height: 1.18;
    margin-bottom: 16px;
  }
}

@media (max-aspect-ratio: 1/1) and (max-height: 1000px) {
  .transition-global {
    --scan-qr-size: clamp(190px, 31vw, 285px);
  }

  .totemBG {
    padding-bottom: 12rem;
  }
}

/* Loader do QR Code */
.qr-loader {
  width: 7.5rem;
  height: 7.5rem;
  animation: qr-loader-rotate 1.4s linear infinite;
}
.qr-loader-track {
  fill: none;
  stroke: rgba(255, 255, 255, 0.2);
  stroke-width: 8;
}
.qr-loader-arc {
  fill: none;
  stroke: url(#qrLoaderGrad);
  stroke-width: 8;
  stroke-linecap: round;
  stroke-dasharray: 180 264;
  transform-origin: center;
  animation: qr-loader-dash 1.6s ease-in-out infinite;
}
@keyframes qr-loader-rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes qr-loader-dash {
  0% {
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dashoffset: -132;
  }
  100% {
    stroke-dashoffset: -264;
  }
}

/* Popup Política de Privacidade - padrão do sistema */
.privacy-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.privacy-popup-content {
  background: white;
  border-radius: 1rem;
  padding: 0;
  max-width: 90vw;
  width: 35rem;
  overflow: hidden;
  box-shadow: 0 0.75rem 2.5rem rgba(0, 0, 0, 0.4);
}

.privacy-popup-header {
  width: 100%;
  padding: 1.5rem;
  text-align: center;
  background: linear-gradient(180deg, #8c2667 0%, #222129 100%);
}

.privacy-popup-title {
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

.privacy-popup-body {
  padding: 1.75rem 1.5rem;
}

.privacy-section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 1rem 0;
}

.privacy-popup-body p {
  font-size: 1rem;
  line-height: 1.6;
  color: #444;
  margin: 0 0 0.75rem 0;
}

.privacy-popup-body p:last-of-type {
  margin-bottom: 0;
}

.privacy-popup-footer {
  padding: 1.25rem 1.5rem 1.5rem;
  display: flex;
  justify-content: center;
}

/* Botão de retry do QR Code. A cor do texto é explícita: o container herda
   `tw-text-white` dos elementos acima, o que deixava o texto invisível sobre o
   fundo branco. */
.btn-tentar-novamente {
  background: #ffffff;
  color: #651946;
  border: none;
  cursor: pointer;
}

.privacy-popup-button {
  background: linear-gradient(135deg, #8c2667, #651946);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.privacy-popup-button:hover {
  transform: translateY(-0.125rem);
  box-shadow: 0 0.375rem 1.25rem rgba(140, 38, 103, 0.4);
}
</style>
